// extracted by mini-css-extract-plugin
export default {"alignmentTool":"alignment_alignmentTool__oNdrs"};